import { CURRENCY_SYMBOLS } from '@/lib/billing/billing';

export const SINGLE_PLAN = 'single';
export const TEAMS_PLAN = 'teams';
export const CUSTOM_PLAN = 'custom';
export const ENTERPRISE_PLAN = 'enterprise';
export const ADVANCED_PLAN = 'advanced';

// New plans
export const AGENCY_PLAN = 'agency';
export const EXCEL_PLAN = 'excel';
export const LAUNCH_PLAN = 'launch';
export const SCALE_PLAN = 'scale';
export const FREE_PLAN = 'free_plan';
export type OnlyNewPlanType =
    | typeof AGENCY_PLAN
    | typeof EXCEL_PLAN
    | typeof LAUNCH_PLAN
    | typeof SCALE_PLAN
    | typeof FREE_PLAN;

export type PlanType = OnlyNewPlanType | 'single' | 'teams' | 'custom' | 'trial' | 'old';
export type PlanFrequencyType = 'monthly' | 'yearly';
export type CurrencyType = keyof typeof CURRENCY_SYMBOLS;
